import {
	ActiveGenerationsResponse,
	activeGenerationsResponseSchema,
	CopywritingReviewedResponse,
	copywritingReviewedResponseSchema,
} from "@signalist/shared-types";

import { api } from "@/redux/api";

import {
	GenerateBatchCopywritingRequest,
	GenerateBatchCopywritingResponse,
	GenerateBatchCopywritingResponseSchema,
	GenerateCopywritingAck,
	GenerateCopywritingAckSchema,
	GenerateCopywritingRequest,
} from "../../pages/Messages/components/GenerateBar/types";

export const copywritingOrchestrationApi = api.injectEndpoints({
	endpoints: (builder) => ({
		/**
		 * Company-scoped live job list of the AI queue pill (PREC-3635 P6). The
		 * response hydrates the slice's job map; the company-room socket keeps it
		 * fresh between fetches.
		 */
		getActiveGenerations: builder.query<ActiveGenerationsResponse, void>({
			query: () => ({
				url: "copywriting-orchestration/active",
				responseSchema: activeGenerationsResponseSchema,
			}),
			providesTags: ["CopywritingOrchestration"],
		}),
		/** Persists the ready-chip consumption marker (review-now, P6 D6). */
		markCopywritingReviewed: builder.mutation<CopywritingReviewedResponse, number>({
			query: (listPersonId) => ({
				url: `copywriting-orchestration/list-persons/${listPersonId}/reviewed`,
				method: "POST",
				responseSchema: copywritingReviewedResponseSchema,
			}),
			invalidatesTags: ["CopywritingOrchestration"],
		}),
		generateCopywriting: builder.mutation<GenerateCopywritingAck, GenerateCopywritingRequest>({
			query: (body) => ({
				url: "copywriting-orchestration/generate",
				method: "POST",
				body,
				responseSchema: GenerateCopywritingAckSchema,
			}),
			invalidatesTags: ["CopywritingOrchestration"],
		}),
		generateBatchCopywriting: builder.mutation<
			GenerateBatchCopywritingResponse,
			GenerateBatchCopywritingRequest
		>({
			query: (body) => ({
				url: "copywriting-orchestration/generate-batch",
				method: "POST",
				body,
				responseSchema: GenerateBatchCopywritingResponseSchema,
			}),
			invalidatesTags: ["CopywritingOrchestration"],
		}),
	}),
});

export const {
	useGenerateCopywritingMutation,
	useGenerateBatchCopywritingMutation,
	useGetActiveGenerationsQuery,
	useMarkCopywritingReviewedMutation,
} = copywritingOrchestrationApi;
